<app-service-detail *ngIf="!embedded">
    <app-variables-tabs primarySelectedTab="Tables" class="container-fluid px-5">
    </app-variables-tabs>
    <div class="col-12 pl-3 pl-md-5 list-header">
        <h1 class="list-header-title">
            {{'Generate fields' | translate}}
        </h1>
    </div>
    <div class="col-12 pl-3 pl-md-5">

        <table class="table table-striped w-100 fields-generator mb-4" *ngIf="rows.length > 0">
            <thead>
                <tr>
                    <th class="text-left">Field Name</th>
                    <th class="text-left">Field Type</th>
                    <th class="text-left">Field Required</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of rows; let rowIndex = index">
                    <td>
                        <span title="Double click to edit" (click)="editing[rowIndex + '-fieldName'] = true" *ngIf="!editing[rowIndex + '-fieldName']">
                            {{row.fieldName}}
                        </span>
                        <input autofocus
                               (blur)="updateValue($event, 'fieldName', rowIndex)"
                               *ngIf="editing[rowIndex+ '-fieldName']"
                               type="text"
                               [value]="row.fieldName" />
                    </td>
                    <td>
                        <span title="Click to edit" (click)="editing[rowIndex + '-fieldType'] = true" *ngIf="!editing[rowIndex + '-fieldType']" class="text-uppercase strong text-075">
                            {{row.fieldType}}
                        </span>
                        <select autofocus
                                *ngIf="editing[rowIndex + '-fieldType']"
                                (blur)="editing[rowIndex + '-fieldType'] = false"
                                (change)="updateValue($event, 'fieldType', rowIndex)"
                                [value]="row.fieldType">
                            <option value="text">Text</option>
                            <option value="number">Number</option>
                            <option value="date">Date</option>
                            <option value="money">Money</option>
                            <option value="boolean">Boolean</option>
                        </select>
                    </td>
                    <td>
                        <span class="d-flex align-items-center">
                            <i class="fas fa-toggle-large-on fa-flip-horizontal green-on-color req-icon" *ngIf="row.fieldRequired == true" (click)="updateValue(false, 'fieldRequired', rowIndex)"></i>
                            <i class="fas fa-toggle-large-off fa-flip-horizontal gray-off-color req-icon" *ngIf="row.fieldRequired == false" (click)="updateValue(true, 'fieldRequired', rowIndex)"></i>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="d-grid grid-template-fields-generator-add-form">
            <div>
                <label for="addField-fieldName">Field Name</label>
                <input id="addField-fieldName" class="form-control" required type="text" (keyup.enter)="addNewField()" [(ngModel)]="fieldName">
            </div>
            <div>
                <label for="addField-fieldType">Field Type</label>
                <select id="addField-fieldType" class="form-control" [(ngModel)]="fieldType">
                    <option value="text">Text</option>
                    <option value="number">Number</option>
                    <option value="date">Date</option>
                    <option value="money">Money</option>
                    <option value="boolean">Boolean</option>
                </select>
            </div>
            <div class="d-flex align-items-flex-end">
                <div class="add-field-btn-container d-flex">
                    <input type="checkbox" id="addField-fieldRequired" class="toggle-check" [(ngModel)]="fieldRequired" />
                    <label for="addField-fieldRequired" class="align-items-center check-icon-label d-flex mr-3">
                        <span class="check-on"><i class="fas fa-toggle-large-on fa-flip-horizontal green-on-color req-icon mr-2"></i> Field Required</span>
                        <span class="check-off"><i class="fas fa-toggle-large-off fa-flip-horizontal gray-off-color req-icon mr-2"></i> Field Required</span>
                    </label>
                    <primary-text-button (onClick)="addNewField()">{{'Add new field' | translate }}</primary-text-button>
                </div>
            </div>
        </div>
        <div class="mt-2">
            <primary-text-button (onClick)="generateForm()">{{'Generate form block' | translate }}</primary-text-button>
        </div>

    </div>
</app-service-detail>

<div *ngIf="embedded">
    <div class="moving">
        <layer-header
            (closeLayer)="cancel()"
            [listIcons]="false"
            [title]="'Generate fields' | translate">
        </layer-header>
        <div class="row">
            <div class="col-12">            
                <table class="table table-striped w-100 fields-generator mb-4" *ngIf="rows.length > 0">
                    <thead>
                        <tr>
                            <th class="text-left">Field Name</th>
                            <th class="text-left">Field Type</th>
                            <th class="text-left">Field Required</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of rows; let rowIndex = index">
                            <td>
                                <span title="Double click to edit" (click)="editing[rowIndex + '-fieldName'] = true" *ngIf="!editing[rowIndex + '-fieldName']">
                                    {{row.fieldName}}
                                </span>
                                <input  autofocus
                                        (blur)="updateValue($event, 'fieldName', rowIndex)"
                                        *ngIf="editing[rowIndex+ '-fieldName']"
                                        type="text"
                                        [value]="row.fieldName" />
                            </td>
                            <td>
                                <span title="Click to edit" (click)="editing[rowIndex + '-fieldType'] = true" *ngIf="!editing[rowIndex + '-fieldType']" class="text-uppercase strong text-075">
                                    {{row.fieldType}}
                                </span>
                                <select autofocus
                                        *ngIf="editing[rowIndex + '-fieldType']"
                                        (blur)="editing[rowIndex + '-fieldType'] = false"
                                        (change)="updateValue($event, 'fieldType', rowIndex)"
                                        [value]="row.fieldType">
                                    <option value="text">Text</option>
                                    <option value="number">Number</option>
                                    <option value="date">Date</option>
                                    <option value="money">Money</option>
                                    <option value="boolean">Boolean</option>
                                </select>
                            </td>
                            <td>
                                <span class="d-flex align-items-center">
                                    <i class="fas fa-toggle-large-on fa-flip-horizontal green-on-color req-icon" *ngIf="row.fieldRequired == true" (click)="updateValue(false, 'fieldRequired', rowIndex)"></i>
                                    <i class="fas fa-toggle-large-off fa-flip-horizontal gray-off-color req-icon" *ngIf="row.fieldRequired == false" (click)="updateValue(true, 'fieldRequired', rowIndex)"></i>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>        
                <div class="d-grid grid-template-fields-generator-add-form">
                    <div>
                        <label for="addField-fieldName">Field Name</label>
                        <input id="addField-fieldName" class="form-control" required type="text" (keyup.enter)="addNewField()" [(ngModel)]="fieldName">
                    </div>
                    <div>
                        <label for="addField-fieldType">Field Type</label>
                        <select id="addField-fieldType" class="form-control" [(ngModel)]="fieldType">
                            <option value="text">Text</option>
                            <option value="number">Number</option>
                            <option value="date">Date</option>
                            <option value="money">Money</option>
                            <option value="boolean">Boolean</option>
                        </select>
                    </div>
                    <div class="d-flex align-items-flex-end">
                        <div class="add-field-btn-container d-flex">
                            <input type="checkbox" id="addField-fieldRequired" class="toggle-check" [(ngModel)]="fieldRequired" />
                            <label for="addField-fieldRequired" class="align-items-center check-icon-label d-flex mr-3">
                                <span class="check-on"><i class="fas fa-toggle-large-on fa-flip-horizontal green-on-color req-icon mr-2"></i> Field Required</span>
                                <span class="check-off"><i class="fas fa-toggle-large-off fa-flip-horizontal gray-off-color req-icon mr-2"></i> Field Required</span>
                            </label>
                            <primary-text-button (onClick)="addNewField()">{{'Add new field' | translate }}</primary-text-button>
                        </div>
                    </div>
                </div>
                <div class="mt-2">
                    <primary-text-button (onClick)="generateForm()">{{'Generate form block' | translate }}</primary-text-button>
                </div>
            </div>
        </div>
    </div>
</div>